<template>
    <div>
        <Loading :active="isLoading" :can-cancel="true" :is-full-page="fullPage" />
        <b-container class="pt-4 pb-4">
            <b-row>
                <b-col cols="2"></b-col>
                <b-col>
                    <b-card
                        header="¿Problemas para acceder su cuenta?"
                    >
                        <b-container class="tarjeta">
                            <b-row>
                                <b-col cols="4">
                                    <img src="../assets/usuario.jpg" alt="">
                                </b-col>
                                <b-col cols="8">
                                    <b-row class="text-center mb-4">
                                        <span>¿Olvidaste tu contraseña?</span><br>
                                        <span>Ingresa tu email y te mandaremos un correo con tu información.</span><br><br>
                                    </b-row>
                                    <b-form @submit.prevent="recuperarContrasena" id="formRecuperarContrasena">
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            label-cols-sm="3"
                                            label-cols-md="2"
                                            content-cols-sm
                                            content-cols-md="9"
                                            description="Por favor ingrese su e-mail."
                                            label="E-mail"
                                            label-for="input-horizontal"
                                        >
                                            <b-form-input type="email" v-model="email" name="email" required></b-form-input>
                                        </b-form-group>
                                        <b-button type="submit">Enviar</b-button>
                                    </b-form>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-card>
                </b-col>
                <b-col cols="2"></b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
const axios = require("axios");
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";

export default {
    name: 'OlvidoPass',
    components: {
        Loading,
    },
    data() {
        return {
            email: '',
            //
            isLoading: false,
            fullPage: true,
        }
    },
    methods: {
        recuperarContrasena() {
            const form = document.getElementById('formRecuperarContrasena')
            var formData = new FormData(form);
            formData.append("accion", "recuperarContrasena");
            
            this.isLoading = true;
            axios.post(`${this.url}/ajax/ajax.usuarios.php`, formData)
            .then(res => {
                this.isLoading = false

                if (res.data.estado == 'ok') {
                    Swal.fire({
                        title: "Datos enviados",
                        text: res.data.mensaje,
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#3085d6",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.$router.push(`/inicio`)
                        }
                    })
                } else {
                    Swal.fire({
                        title: "Atención",
                        text: res.data.mensaje,
                        icon: "error",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#3085d6",
                    });
                }
            });
        },
    },
    computed: {
        url() {
            if (["localhost", "127.0.0.1", ""].includes(window.location.hostname)) {
                return this.urlSandbox;
            } else {
                return this.urlProd;
            }
        },
        ...mapState(["urlProd"]),
        ...mapState(["urlSandbox"]),
    }
}
</script>

<style>
    .tarjeta {
        padding-top: 50px;
        padding-bottom: 120px;
    }
</style>